interface GuardianFamilyData {
  nominatedBy: string | null
  nominatorContact: string | null
  guardianName: string | null
  guardianPhone: string | null
  guardianEmail: string | null
  guardianRelationship: string | null
  familyCircumstances: string | null
  notes: string | null
}

export function GuardianFamilyCard({ child }: { child: GuardianFamilyData }) {
  return (
    <div className="rounded-[10px] border border-gold-500 bg-white p-5">
      <h2 className="font-display text-sm font-bold uppercase tracking-wider text-forest-700">Guardian & Family</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <p className="text-xs text-ink/50">Nominated by</p>
          <p className="text-sm font-medium text-ink">{child.nominatedBy || "—"}</p>
        </div>
        <div>
          <p className="text-xs text-ink/50">Nominator contact</p>
          <p className="text-sm font-medium text-ink">{child.nominatorContact || "—"}</p>
        </div>
        <div>
          <p className="text-xs text-ink/50">Guardian</p>
          <p className="text-sm font-medium text-ink">{child.guardianName || "—"}</p>
        </div>
        <div>
          <p className="text-xs text-ink/50">Relationship</p>
          <p className="text-sm font-medium text-ink">{child.guardianRelationship || "—"}</p>
        </div>
        <div>
          <p className="text-xs text-ink/50">Phone</p>
          <p className="text-sm font-medium text-ink">{child.guardianPhone || "—"}</p>
        </div>
        <div>
          <p className="text-xs text-ink/50">Email</p>
          <p className="break-words text-sm font-medium text-ink">{child.guardianEmail || "—"}</p>
        </div>
      </div>
      <div className="mt-4 rounded-lg bg-cream-100 p-3">
        <p className="text-sm font-medium text-ink">Family Circumstances</p>
        <p className="mt-1 whitespace-pre-wrap text-sm text-ink/70">
          {child.familyCircumstances || child.notes || "No family information recorded."}
        </p>
      </div>
    </div>
  )
}
